import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericAlertChangeAccount } from '@app/shared/models/generic-alert-change-account.model';

@Component({
  templateUrl: './modal-alert-change-account.component.html',
  styleUrls: ['./modal-alert-change-account.component.scss']
})
export class ModalConfirmAlertChangeAccountComponent {
  dialogData: GenericAlertChangeAccount;

  constructor(public dialogRef: MatDialogRef<ModalConfirmAlertChangeAccountComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericAlertChangeAccount) {
    this.dialogData = data;
  }

  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }
}
